import * as React           from 'react'

import Grid                       from '@material-ui/core/Grid'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles'
import withTheme, { WithTheme }   from '@material-ui/core/styles/withTheme'
import Typography                 from '@material-ui/core/Typography'

import { Program } from '../../api'
import loadable    from '../hocs/loadable'


interface ProgramSummaryProps {
  program: Program
}

const styles = theme => ({
  summaryContainer: {
    [ theme.breakpoints.down('xs') ]: {
      justifyContent: 'center',
      flexDirection:  'column' as any,
    }
  }
})

type Props =
  ProgramSummaryProps
  & WithTheme
  & WithStyles<ReturnType<typeof styles>>

const ProgramSummary = withStyles(styles)(({
  program,
}: Props) => {
  const {
    details:
      {
        name,
      },
  } = program

  const titleBar = (
    <Grid item>
      <Grid
        container
        spacing={40}
        justify={'space-between'}
        alignItems={'center'}
      >
        <Grid item>
          <Typography variant={'title'}>
            {name}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )

  return (
    <Grid  container  spacing={40}>
      {titleBar}
    </Grid>
  )
})

export default loadable(withTheme()<ProgramSummaryProps>(ProgramSummary))



// WEBPACK FOOTER //
// ./src/components/molecules/ProgramSummary.tsx